import {ButtonBase, Grid, Typography} from "@mui/material";
import { useResponsive } from "../../../Modulo_Responsive/Hooks/useResponsive";
import Lista_Blogs from "./SubComponentes/Lista_Blogs";
import Lista from "./SubComponentes/Lista";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const Problema_Home = () => {
    const { sCell } = useResponsive();

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12, sm: 12, md: 12 }}
            sx={{background:'#F5F6F7', py:sCell?8:16}}
            component="section"
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                size={{ xs: 12, sm: 12, md: 10 }}
                sx={{ maxWidth: 1400, px: 3 }}
            >
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'center'}
                    size={{ xs: 12, sm: 12, md: 12 }}
                >
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{ xs: 12, sm: 12, md: 12 }}
                    >
                        <Typography
                            component="h2"
                            variant="h2"
                            sx={{
                                textAlign: 'center',
                            }}
                            itemProp="name"
                        >
                            Concejos y recomendaciones
                        </Typography>
                    </Grid>
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        size={{ xs: 12, sm: 12, md: 12 }}
                        sx={{ pt: 8 }}
                    >
                        <Lista ids={["1", "2", "3"]} />
                    </Grid>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        size={{ xs: 12, sm: 12, md: 12 }}
                        sx={{ pt: 12 }}
                    >
                        <ButtonBase
                            href={'/blogs/'}
                            sx={{
                                color: "#fff",
                                fontSize: sCell ? '16px' : '16px',
                                fontWeight: 600,
                                textTransform: "none",
                            }}
                        >
                            <Typography
                                variant="body1"
                                sx={{ fontSize: 15, fontWeight: 500, color: "#223B59" }}
                            >
                                Ver más
                            </Typography>
                            <ArrowForwardIosIcon sx={{ fontSize: 13, color: "#223B59", ml: 0.5 }} />
                        </ButtonBase>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Problema_Home;